/**
 * Handle list / map display
 */

const list = document.querySelector('.page-list');

if(list) {
  const mapButton = document.querySelector('.js-button-map');
  const listButton = document.querySelector('.js-button-list');
  const listSection = list.querySelector('.page-list__list');
  const mapSection = document.querySelector('.page-list__map');

  if (mapButton) {
    mapButton.addEventListener('click',() =>  {
      mapButton.classList.add('is-hidden');
      listSection.classList.remove('toggled');
      listButton.classList.remove('is-hidden');
      mapSection.classList.add('toggled');

    });
  }
  if (listButton) {
    listButton.addEventListener('click',() =>  {
      listButton.classList.add('is-hidden');
      mapSection.classList.remove('toggled');
      mapButton.classList.remove('is-hidden');
      listSection.classList.add('toggled');
    });
  }
}


